
import {define} from "observable:runtime";
import asset1 from "./style.css?url";
import asset2 from "./favicon.svg?url";

const assets = new Map([
  ["./style.css", asset1],
  ["./favicon.svg", asset2]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {createUI, installHashImportBanner, installThemeToggle, runWithConsole, runAndExtract} = await import("./lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  if (!("runWithConsole" in module)) throw new SyntaxError(`export 'runWithConsole' not found`);
  if (!("runAndExtract" in module)) throw new SyntaxError(`export 'runAndExtract' not found`);
  return module;
});
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, ok, err, hint, consoleOutput } = createUI({ html });
return {createUI,installHashImportBanner,installThemeToggle,runWithConsole,runAndExtract,codeEditor,ok,err,hint,consoleOutput};
},
    inputs: ["html","display"],
    outputs: ["createUI","installHashImportBanner","installThemeToggle","runWithConsole","runAndExtract","codeEditor","ok","err","hint","consoleOutput"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-5`),
    expanded: [],
    variables: []
  },
  {
    id: 5,
    body: (view,codeEditor) => {
const demo_decl = view(codeEditor("variables:demo_decl", {
  value: 'let message = "Hallo"\nconsole.log(message)'
}));
return {demo_decl};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_decl"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-6`),
    expanded: [],
    variables: []
  },
  {
    id: 6,
    body: async (display,consoleOutput,runWithConsole,demo_decl) => {
display(consoleOutput(await runWithConsole(demo_decl)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_decl"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-9`),
    expanded: [],
    variables: []
  },
  {
    id: 9,
    body: (view,codeEditor) => {
const demo_assign = view(codeEditor("variables:demo_assign", {
  value: 'let message = "Hallo"\nconsole.log(message)\n\nmessage = "Guten Morgen"\nconsole.log(message)'
}));
return {demo_assign};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_assign"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-10`),
    expanded: [],
    variables: []
  },
  {
    id: 10,
    body: async (display,consoleOutput,runWithConsole,demo_assign) => {
display(consoleOutput(await runWithConsole(demo_assign)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_assign"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-12`),
    expanded: [],
    variables: []
  },
  {
    id: 12,
    body: (view,codeEditor) => {
const demo_access = view(codeEditor("variables:demo_access", {
  value: 'console.log("Ich schreibe Javascript")\n\nlet foo = "Hello World"\nconsole.log(foo)'
}));
return {demo_access};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_access"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-13`),
    expanded: [],
    variables: []
  },
  {
    id: 13,
    body: async (display,consoleOutput,runWithConsole,demo_access) => {
display(consoleOutput(await runWithConsole(demo_access)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_access"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-15`),
    expanded: [],
    variables: []
  },
  {
    id: 15,
    body: (view,codeEditor) => {
const demo_combine = view(codeEditor("variables:demo_combine", {
  value: 'let animal = "Cat"\nlet foo = animal\nconsole.log(foo)'
}));
return {demo_combine};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_combine"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-16`),
    expanded: [],
    variables: []
  },
  {
    id: 16,
    body: async (display,consoleOutput,runWithConsole,demo_combine) => {
display(consoleOutput(await runWithConsole(demo_combine)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_combine"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-19`),
    expanded: [],
    variables: []
  },
  {
    id: 19,
    body: (view,codeEditor) => {
const mini_code = view(codeEditor("variables:mini", {
  value: '// dein Code hier'
}));
return {mini_code};
},
    inputs: ["view","codeEditor"],
    outputs: ["mini_code"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-20`),
    expanded: [],
    variables: []
  },
  {
    id: 20,
    body: async (runWithConsole,mini_code,display,consoleOutput) => {
const miniRun = await runWithConsole(mini_code);
display(consoleOutput(miniRun));
return {miniRun};
},
    inputs: ["runWithConsole","mini_code","display","consoleOutput"],
    outputs: ["miniRun"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-21`),
    expanded: [],
    variables: []
  },
  {
    id: 21,
    body: (mini_code,display,hint,html,miniRun,err,ok) => {
{
  const src = mini_code.trim();
  const declares = /\b(let|const)\s+lieblingstier\s*=/.test(src);
  const logs = /console\s*\.\s*log\s*\(\s*lieblingstier\s*\)/.test(src);
  const stringValue = /=\s*["'`][^"'`]+["'`]/.test(src);

  if (!src || src === "// dein Code hier")
    display(hint(html`Schreib deinen Code in das Feld oben.`));
  else if (miniRun.error)
    display(err(html`Fehler: ${miniRun.error}`));
  else if (!declares)
    display(err(html`Du brauchst eine Variable namens <code>lieblingstier</code> (mit <code>let</code> oder <code>const</code>).`));
  else if (!stringValue)
    display(err(html`Der Wert sollte ein String sein, also in Anführungszeichen stehen.`));
  else if (!logs)
    display(err(html`Vergiss nicht, <code>lieblingstier</code> mit <code>console.log(lieblingstier)</code> auszugeben.`));
  else
    display(ok(html`Super! Dein Lieblingstier ist auf der Konsole gelandet.`));
}
},
    inputs: ["mini_code","display","hint","html","miniRun","err","ok"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-23`),
    expanded: [],
    variables: []
  },
  {
    id: 23,
    body: (view,codeEditor) => {
const demo_const = view(codeEditor("variables:demo_const", {
  value: 'const pi = 3.141\nconsole.log(pi)\n\npi = 4 // <-- das geht nicht!'
}));
return {demo_const};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_const"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-24`),
    expanded: [],
    variables: []
  },
  {
    id: 24,
    body: async (display,consoleOutput,runWithConsole,demo_const) => {
display(consoleOutput(await runWithConsole(demo_const)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_const"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-27`),
    expanded: [],
    variables: []
  },
  {
    id: 27,
    body: (view,codeEditor) => {
const uebung_code = view(codeEditor("variables:final", {
  value: ""
}));
return {uebung_code};
},
    inputs: ["view","codeEditor"],
    outputs: ["uebung_code"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-28`),
    expanded: [],
    variables: []
  },
  {
    id: 28,
    body: async (runWithConsole,uebung_code) => {
const uebungRun = await runWithConsole(uebung_code);
return {uebungRun};
},
    inputs: ["runWithConsole","uebung_code"],
    outputs: ["uebungRun"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-29`),
    expanded: [],
    variables: []
  },
  {
    id: 29,
    body: (display,consoleOutput,uebungRun) => {
display(consoleOutput(uebungRun));
},
    inputs: ["display","consoleOutput","uebungRun"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-30`),
    expanded: [],
    variables: []
  },
  {
    id: 30,
    body: (uebung_code,display,hint,html,uebungRun,err,ok) => {
{
  const src = uebung_code;
  const hasConstName = /\bconst\s+name\s*=\s*["'`][^"'`]+["'`]/.test(src);
  const hasLetAwesome = /\blet\s+awesomePerson\b/.test(src);
  const assignsAwesome = /\bawesomePerson\s*=\s*name\b/.test(src);
  const logsAwesome = /console\s*\.\s*log\s*\(\s*awesomePerson\s*\)/.test(src);

  if (!src.trim())
    display(hint(html`Fang an, die drei Schritte oben umzusetzen.`));
  else if (uebungRun.error)
    display(err(html`Fehler: ${uebungRun.error}`));
  else if (!hasConstName)
    display(err(html`Schritt 1 fehlt: <code>const name = "..."</code> mit deinem Namen.`));
  else if (!hasLetAwesome)
    display(err(html`Schritt 2 fehlt: deklariere <code>awesomePerson</code> mit <code>let</code>.`));
  else if (!assignsAwesome)
    display(err(html`Schritt 2 fehlt: befülle <code>awesomePerson</code> mit dem Wert von <code>name</code> (<code>awesomePerson = name</code> oder direkt in der <code>let</code>-Zeile).`));
  else if (!logsAwesome)
    display(err(html`Schritt 3 fehlt: gib <code>awesomePerson</code> mit <code>console.log(awesomePerson)</code> aus.`));
  else if (uebungRun.logs.length === 0)
    display(err(html`Dein <code>console.log</code> hat nichts ausgegeben — schau, ob du den Code wirklich aufrufst.`));
  else
    display(ok(html`🎉 Übung gelöst! Hallo, ${uebungRun.logs[uebungRun.logs.length - 1]}.`));
}
},
    inputs: ["uebung_code","display","hint","html","uebungRun","err","ok"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
